import { render, staticRenderFns } from "./HealthCoverForm.vue?vue&type=template&id=3ad9b5f9"
import script from "./HealthCoverForm.vue?vue&type=script&lang=ts"
export * from "./HealthCoverForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports